import React from 'react';

const EmailSuccess = () => {
    return (
        <div class="m-6 lg:m-20">
            <div class="pb-0 lg:pb-4 pt-4 lg:pt-0">
                <a
                    class="flex items-center text-white no-underline hover:no-underline font-bold text-4xl lg:text-5xl"
                    href="/"
                >
                    PNK
                </a>
            </div>
            <div class="flex flex-col w-full justify-center lg:items-start overflow-y-hidden">
                <h1 class="my-6 text-3xl md:text-4xl text-white opacity-75 font-bold leading-tight text-left">
                    Email sent successfully! 🚀
                </h1>

                <p class="leading-normal text-base text-white md:text-2xl mb-8 text-left lg:pb-5">
                    We will process your request as soon as possible 🤗
                </p>
            </div>
        </div>
    );
};

export default EmailSuccess;
